export default "__VITE_ASSET__DbFpXlbO__"